/*doc
---
title: hidden()
name: hidden
category: Javascript - General
---

This is a custom version of [jQuery's `hide()`](http://api.jquery.com/hide/) **Use this instead of `hide()`**

This version use's the Bootstrap `hidden` class to set the element as hidden, it
also will set the `aria-hidden` attribute to `true`.

```html_example
<button type="button" class="hidden-example-btn btn btn-lg btn-primary">Hide</button>

<h1 class="hidden-example">This will be hidden</h1>
```

```js_example
$(document).on('turbolinks:load', function() {
  $('.hidden-example-btn').click(function() {
    $('.hidden-example').hidden()
  })
})
```
*/
(function ($) {
  'use strict'

  $.fn.hidden = hidden

  function hidden() {
    return this.each(function() {
      $(this)
        .addClass('hidden')
        .attr('aria-hidden', true)
    })
  }

}(jQuery))
